export var Jurisdiction;

(function (Jurisdiction) {
  Jurisdiction["COM"] = "com";
  Jurisdiction["ES"] = "es";
  Jurisdiction["IT"] = "it";
})(Jurisdiction || (Jurisdiction = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90eXBlcy9KdXJpc2RpY3Rpb24udHMiXSwibmFtZXMiOlsiSnVyaXNkaWN0aW9uIl0sIm1hcHBpbmdzIjoiQUFBQSxXQUFZQSxZQUFaOztXQUFZQSxZO0FBQUFBLEVBQUFBLFk7QUFBQUEsRUFBQUEsWTtBQUFBQSxFQUFBQSxZO0dBQUFBLFksS0FBQUEsWSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBlbnVtIEp1cmlzZGljdGlvbiB7XG4gIENPTSA9ICdjb20nLFxuICBFUyA9ICdlcycsXG4gIElUID0gJ2l0Jyxcbn1cbiJdfQ==